
// ABOUTME: Billing page with URL routing support
// ABOUTME: Displays billing information and payment management

import React from 'react';
import Billing from '@/components/billing/Billing';

const BillingPage = () => {
  return <Billing />;
};

export default BillingPage;
